import { PackageFields } from '@openx/types/package.ts';
import { useWatch } from 'react-hook-form';
import { useTargetingBlockingRules } from '../targetingRules/useTargetingBlockingRules.ts';

export const useTargetingBusinessRequirements = () => {
  const observableTargeting = useWatch({
    name: PackageFields.TARGETING,
  });

  const { fieldsWithErrors, isTargetingBlockingRulesSchemaLoading, isTargetingBlockingRulesValidationPending } =
    useTargetingBlockingRules({
      targeting: observableTargeting,
    });

  return {
    isTargetingBlockingRulesSchemaLoading,
    isTargetingBlockingRulesValidationPending,
    meetsBusinessRequirements: !isTargetingBlockingRulesValidationPending && Object.keys(fieldsWithErrors).length === 0,
  };
};
